import { CircularProgress } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { JupiterTheme } from '../../../theme/types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    progressContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      padding: theme.spacing(2),
    },
    progress: {
      width: theme.spacing(10),
      height: theme.spacing(10),
    },
  })
);

export default function RawDataProgress() {
  const classes = useStyles();

  return (
    <div className={classes.progressContainer}>
      <CircularProgress className={classes.progress} />
    </div>
  );
}
